// JavaScript Document
// Version: 2.0.1

var printAreasAdvancedSettings    = minerva_configurator_vars.print_areas_advanced_settings;
var refillsAdvancedSettings       = minerva_configurator_vars.refills_advanced_settings;
var markerSwitches                = {};
var fontFamilySelectPickerOptions = {
	style: 'btn-default btn-ghost btn-negative',
	size: 10,
	width: false
};
var fontSizeSelectPickerOptions   = {
	style: 'btn-default btn-ghost btn-negative',
	size: 10,
	width: false,
};
var printAreasSelectPickerOptions = {
	style: 'btn-default btn-ghost',
	size: 'auto',
	width: '100%',
	hideDisabled: true
};
var printAreaContentInfo          = {};
var fabricBorderColor             = '#0000ff';
var fabricCornerColor             = '#0000ff';
var mergeCanvasItems              = [];



jQuery(document).ready(function($) {
    /**
	 * Gestisce le tab verticali relative alle aree di stampa.
	 *
	 * @since 1.0.0
	 */
	$('#v-pills-printareas-tab .nav-link').on('click', function(e) {
		var that   = $(this);
		var areaId = that.data('area-id');

		$('.pen-preview .print-area.active').removeClass('active');
		$('.pen-preview .print-area[data-area-id="' + areaId + '"]').addClass('active');
	});



	/**
	 * Mostra/Nasconde i marker relativi alle aree di stampa.
	 *
	 * @since 1.0.0
	 */
	$('.print-area-markers-switch').each(function(index, element) {
		var that   = $(element);
		var id     = that.attr('id');
		var status = that.prop('checked');

		markerSwitches[id.replace(/-/g, '_')] = status;
	});

	$('body').on('change', '.print-area-markers-switch', function(e) {
		var that   = $(this);
		var id     = that.attr('id');
		var status = that.prop('checked');

		if ( status != markerSwitches[id.replace(/-/g, '_')] ) {
			$.each(markerSwitches, function(key, value) {
				markerSwitches[key] = status;
			});

			$('.print-area-markers-switch[id!="' + id + '"]').prop('checked', status);
			hidePrintAreaMarkers(status);
		} else {

		}
	});



	/**
	 * Gestisce i pulsanti per muovere l'area di stampa (se applicabile).
	 *
	 * @since 1.0.0
	 */
	$('#v-pills-printareas-tabContent').on('click', '.btn-group.move-area .btn', function() {
		var that          = $(this);

		that.button('toggle');

		var tabsCtx       = getPrintAreaAncestorTabCtx(that);
		var currentTabCtx = getPrintAreaParentTabCtx(that);
		var otherTabCtx   = $('.parent-tab:not(.active)', tabsCtx);
		var activeIndex   = 0;

		$('.btn-group.move-area .btn', currentTabCtx).each(function(index, element) {
			if ( $(element).hasClass('active') ) {
				activeIndex = index;
			}
		});

		$('.btn-group.move-area .btn', otherTabCtx).each(function(index, element) {
			if ( index == activeIndex ) {
				$(element).addClass('active');
			} else {
				$(element).removeClass('active');
			}
		});
	});



	/**
	 * Gestisce lo spostamento dell'area di stampa (se applicabile).
	 *
	 * @since 1.0.0
	 */
	$('#v-pills-printareas-tabContent').on('click', '.move-area', function() {
		var that                = $(this);
		var printAreaCtx        = getPrintAreaParentTabCtx(that);
		var areaId              = printAreaCtx.data('area-id');
		var previewPrintAreaCtx = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var topOffset           = $('.active input[type="radio"]', that).data('top-offset');

		previewPrintAreaCtx.css('top', topOffset + 'px');
	});



    /**
	 * Inizializza il controllo "selectpicker".
	 *
	 * @since 1.1.0
	 */
	$('.selectpicker.font-family', getImprintMainCtx()).selectpicker(fontFamilySelectPickerOptions);

	$('.selectpicker.font-size', getImprintMainCtx()).selectpicker(fontSizeSelectPickerOptions);

	$('.selectpicker.nav-pills-printareas-tab-dropdown', getImprintMainCtx()).selectpicker(printAreasSelectPickerOptions);



    /**
	 * Gestisce la selezione delle tab relative alle aree di stampa.
	 *
	 * @since 1.1.0
	 */
	$('.nav-pills-printareas-tab-dropdown').on('change', function() {
		var ctx    = getPrintAreaTabsCtx();
		var tabId  = $('option:selected', $(this)).data('href');
		var areaId = $('option:selected', $(this)).data('area-id');

		$('.tab-pane.ancestor-tab.active', ctx).removeClass('active');
		$(tabId).addClass('active');
		$('.pen-preview .print-area.active').removeClass('active');
		$('.pen-preview .print-area[data-area-id="' + areaId + '"]').addClass('active');
	});



    /**
	 * Inizializza il controllo "rangeslider".
	 *
	 * @since 1.1.0
	 */
	$('input[type="range"]').rangeslider({
		polyfill: false,
	});



});



/**
 * Sposta un'area di stampa.
 *
 * @param {string} printAreaCode : codice dell'area di stampa
 * @param {float}  topOffset     : valore in px
 *
 * @since 1.0.0
 */
function MovePrintArea(printAreaCode, topOffset) {
	jQuery('.pen-preview .print-area[data-area-code="' + printAreaCode + '"]').css('top', topOffset + 'px');
}



/**
 * Mostra/Nasconde i marker relativi alle aree di stampa.
 *
 * @param {bool} status :
 *
 * @since 1.1.0
 */
function hidePrintAreaMarkers(status) {
	if ( status ) {
		jQuery('.pen-preview.imprint .print-area[data-visible="true"]').addClass('no-marker');
	} else {
		jQuery('.pen-preview.imprint .print-area[data-visible="true"]').removeClass('no-marker');
	}
}



/**
 * Aggiunge l'immagine all'area di stampa.
 *
 * @param {string} areaId      : ID dell'area di stanpa
 * @param {string} src         : URL dell'immagine croppata
 * @param {string} source      : stringa identificativa del tipo di oggetto ("image|text-multiline|qrcode")
 *
 * @since 1.0.0
 */
function appendImage(areaId, src, source) {
	if ( null == source ) {
		restoreImage(areaId, src);
	} else {
		var imageCtx      = getPrintAreaTabCtxByAttribute([
			{
				attributeType: 'id',
				attributeValue: source + '-' + areaId,
				dataRelation: '='
			}
		]);
		var imageWidth     = imageCtx.data('area-width');
		var imageHeight    = imageCtx.data('area-height');
		var imageRadius    = imageCtx.data('area-radius');
		var hiImageHeight  = minerva_configurator_vars.hi_image_height;
		var lowImageHeight = minerva_configurator_vars.low_image_height;
		var cf             = hiImageHeight / lowImageHeight;

		/* Le immagini provenienti da LogoEditor, TextEditor e QRcodeEditor vengono unite tramite un canvas "globale" e solo successivamente vengono aggiornate le anteprime */
		var globalCtx      = imageCtx.closest('.tab-pane.ancestor-tab');

		if ( mergeCanvasItems[areaId] == null ) {
			var mergeHiresCanvas = new fabric.Canvas(jQuery('canvas.global-canvas', globalCtx).attr('id'));

			mergeHiresCanvas.setDimensions({
				width: imageWidth * cf,
				height: imageHeight * cf
			});

			mergeCanvasItems[areaId] = { 'mergeHiresCanvas': mergeHiresCanvas };
		} else {
			var exsistingObjs = mergeCanvasItems[areaId].mergeHiresCanvas.getObjects();

			for (var i = 0; i < exsistingObjs.length; i++) {
				if ( exsistingObjs[i].itemType == source ) {
					mergeCanvasItems[areaId].mergeHiresCanvas.remove(exsistingObjs[i]);
				}
			}
		}

		var imgInstance = fabric.Image.fromURL(src, function(image) {
			image.set({
				itemType: source,
				top: 0,
				left: 0
			});

			mergeCanvasItems[areaId].mergeHiresCanvas.add(image);
			mergeCanvasItems[areaId].mergeHiresCanvas.renderAll();
			refreshMergedImages(areaId, source);
		});
	}
}



/**
 * Aggiunge l'immagine all'area di stampa in seguito al restore di una configurazione.
 *
 * @param {string} areaId : ID dell'area di stanpa
 * @param {string} src    : base64 dell'immagine
 *
 * @since 1.2.0
 */
function restoreImage(areaId, src) {
	var imageCtx            = getPrintAreaTabCtxByAttribute([
        {
            attributeType: 'id',
            attributeValue: 'image-' + areaId,
            dataRelation: '='
        }
    ]);
    var imageWidth          = imageCtx.data('area-width');
    var imageHeight         = imageCtx.data('area-height');
    var imageMarginLeft     = imageWidth / 2;
    var previewCtx          = getPreviewPrintAreaCtxByDataAttribute([
        {
            dataAttribute: 'area-id',
            attributeValue: areaId,
            dataRelation: '='
        }
    ]);
    var printAreaWidth      = previewCtx.css('width');
    var printAreaHeight     = previewCtx.css('height');
    var containerWidth      = printAreaWidth;
    var containerHeight     = printAreaHeight;
    var containerLeftOffset = '50%';
    var containerTopOffset  = '50%';
    var containerMarginTop  = parseFloat(containerHeight.replace(/[^-\d\.]/g, '')) / -2;
    var attr                = previewCtx.data('image-shift');
    var imageShift          = ( typeof attr !== typeof undefined && attr !== false ) ? parseFloat(attr) : 0;
    var containerMarginLeft = parseFloat(containerWidth.replace(/[^-\d\.]/g, '')) / -2 + imageShift;
    var content             = '';
    var view                = previewCtx.closest('.view').attr('data-view-code');

    content                += '<div data-area-id="' + areaId + '" class="print-area-content" style="position:absolute; z-index:201; width:' + containerWidth + '; height:' + containerHeight + '; top:' + containerTopOffset + '; left:' + containerLeftOffset + '; margin-left:' + containerMarginLeft + 'px; margin-top:' + containerMarginTop + 'px;">';
    content                += '<img src="' + src + '" style="position:absolute; left:50%; margin-left:-' + imageMarginLeft + 'px; height:auto; width:' + imageWidth + 'px;">';
    content                += '</div>';

    previewCtx.html(content);
}



/**
 * Aggiorna la preview di un'area di stampa in base al canvas globale relativo.
 *
 * @param {string} areaId     : ID dell'area di stanpa
 * @param {string} previewCtx : contesto della preview
 *
 * @since 1.2.0
 */
function refreshMergedImages(areaId, source) {
	var previewCtx      = getPreviewPrintAreaCtxByDataAttribute([
		{
			dataAttribute: 'area-id',
			attributeValue: areaId,
			dataRelation: '='
		}
	]);
	var imageCtx        = getPrintAreaTabCtxByAttribute([
		{
			attributeType: 'id',
			attributeValue: source + '-' + areaId,
			dataRelation: '='
		}
	]);
	var imageWidth      = imageCtx.data('area-width');
	var imageHeight     = imageCtx.data('area-height');
	var imageMarginLeft = imageWidth / 2;
	var mergedImagesSrc = '';

	if (mergeCanvasItems.length > 0 && areaId in mergeCanvasItems) {
		mergedImagesSrc = mergeCanvasItems[areaId].mergeHiresCanvas.toDataURL({
			left: 0,
			top: 0,
			width: mergeCanvasItems[areaId].mergeHiresCanvas.width,
			height: mergeCanvasItems[areaId].mergeHiresCanvas.height
		});
	}


	// Il ciclo $.each è necessario perché un'area di stampa può essere visible su più viste, quindi risulta formalmente suddivisa in tante aree di stampa con il medesimo ID.
	previewCtx.each(function(index, element) {
		var that                = jQuery(element);
		var printAreaWidth      = that.css('width');
		var printAreaHeight     = that.css('height');
		var containerWidth      = printAreaWidth;
		var containerHeight     = printAreaHeight;
		var containerLeftOffset = '50%';
		var containerTopOffset  = '50%';
		var containerMarginTop  = parseFloat(containerHeight.replace(/[^-\d\.]/g, '')) / -2;
		var attr                = that.data('image-shift');
		var imageShift          = ( typeof attr !== typeof undefined && attr !== false ) ? parseFloat(attr) : 0;
		var containerMarginLeft = parseFloat(containerWidth.replace(/[^-\d\.]/g, '')) / -2 + imageShift;
		var content             = '';
		var view                = that.closest('.view').attr('data-view-code');

		// Verifico se esistono più aree di stampa esclusive.
		// Se viene caricata un'immagine in una di esse, l'immagine caricata in precedenza su una delle altre deve essere rimossa.
		var searchCtx           = jQuery('div[data-view-code="' + view + '"]', getPreviewCtx('imprint'));
		var searchPreviewCtx    = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '!='
			},
		], searchCtx);


		searchPreviewCtx.each(function(i, el) {
			var printArea = jQuery(el);

			if ( collision(that, printArea) ) {
				var printAreaId     = printArea.attr('data-area-id');
				var contentToRemove = getPreviewPrintAreaCtxByDataAttribute([
					{
						dataAttribute: 'area-id',
						attributeValue: printAreaId,
						dataRelation: '='
					}
				]);

				contentToRemove.each(function(index, element) {
					getPreviewPrintAreaContentCtx(jQuery(element)).remove();
				});
			}
		});

		content += '<div data-area-id="' + areaId + '" class="print-area-content" style="position:absolute; z-index:201; width:' + containerWidth + '; height:' + containerHeight + '; top:' + containerTopOffset + '; left:' + containerLeftOffset + '; margin-left:' + containerMarginLeft + 'px; margin-top:' + containerMarginTop + 'px;">';
		//imageWidth = (imageWidth > parseFloat(containerWidth)) ? parseFloat(containerWidth) : imageWidth;

		if ('' != mergedImagesSrc) {
			content += '<img src="' + mergedImagesSrc + '" style="position:absolute; left:50%; margin-left:-' + imageMarginLeft + 'px; height:auto; width:' + imageWidth + 'px;">';
		}

		content += '</div>';

		that.html(content);
	});
}



/**
 * Rimuove un oggetto dal canvas globale della specifica area di stampa
 *
 * @param {string} areaId : ID dell'area di stanpa
 * @param {string} source : stringa identificativa del tipo di oggetto ("image|text-multiline|qrcode")
 *
 * @since 1.2.0
 */
function removeImage(areaId, source) {
	if (mergeCanvasItems.length > 0 && areaId in mergeCanvasItems) {
		var exsistingObjs = mergeCanvasItems[areaId].mergeHiresCanvas.getObjects();

		for (var i = 0; i < exsistingObjs.length; i++) {
			if ( exsistingObjs[i].itemType == source ) {
				mergeCanvasItems[areaId].mergeHiresCanvas.remove(exsistingObjs[i]);
			}
		}
	}

	refreshMergedImages(areaId, source);
}



/**
 * Verifica se due aree di stampa si sovrappongono, cioè sono esclusive.
 *
 * @param {selector} currentPrintArea : area di stampa che si sta personalizzando
 * @param {selector} printArea        : area di stampa da verificare
 *
 * @since 1.0.0
 */
function collision(currentPrintArea, printArea) {
	// {transform} può essere:
	//    - undefined
	//    - 'matrix(0.5, 0, 0, 0.5, 0, -190)'
	//    - 'none'
	var transformValue = jQuery('.pen-preview-imprint-wrapper').css('transform');

	if ( transformValue.indexOf('matrix') > -1 ) {
		var matrixRegex = /matrix\(\s*(-?\d*\.?\d*),\s*(-?\d*\.?\d*),\s*(-?\d*\.?\d*),\s*(-?\d*\.?\d*),\s*(-?\d*\.?\d*),\s*(-?\d*\.?\d*)\)/;

	    matches         = jQuery('.pen-preview-imprint-wrapper').css('transform').match(matrixRegex);

		var scaleX      = matches[1];
		var scaleY      = matches[2];
		var scale       = Math.sqrt(scaleX * scaleX + scaleY * scaleY);
	} else {
		scale = 1;
	}

	var x1    = currentPrintArea.offset().left;
	var y1    = currentPrintArea.offset().top;
	var h1    = currentPrintArea.outerHeight(true);
	var w1    = currentPrintArea.outerWidth(true);
	var b1    = y1 + h1 * scale;
	var r1    = x1 + w1 * scale;
	var x2    = printArea.offset().left;
	var y2    = printArea.offset().top;
	var h2    = printArea.outerHeight(true);
	var w2    = printArea.outerWidth(true);
	var b2    = y2 + h2 * scale;
	var r2    = x2 + w2 * scale;

	if ( b1 < y2 || y1 > b2 || r1 < x2 || x1 > r2 )
		return false;

	return true;
}
